import { render, staticRenderFns } from "./protocol-detail.vue?vue&type=template&id=d4961068"
import script from "./protocol-detail.vue?vue&type=script&lang=ts"
export * from "./protocol-detail.vue?vue&type=script&lang=ts"
import style0 from "./protocol-detail.vue?vue&type=style&index=0&id=d4961068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports